/** Liste fehlender/unbestätigter Angaben (leer = vollständig). */
export function detectMissingInputs(plane) {
    const missing = [];
    if (plane.vertices.length < 3) {
        missing.push("Dachpolygon unvollständig (≥ 3 Punkte nötig).");
    }
    if (!plane.scaleConfirmed) {
        missing.push("Maßstab nicht bestätigt — Fläche und Modulanzahl sind unsicher.");
    }
    if (!plane.tiltConfirmed) {
        missing.push("Dachneigung nicht bestätigt — Ertrag und Reihenabstand sind Annahmen.");
    }
    if (!Number.isFinite(plane.azimuthDeg)) {
        missing.push("Ausrichtung (Azimut) fehlt.");
    }
    return missing;
}
//# sourceMappingURL=missing.js.map